import { createServerFn } from "@tanstack/react-start";
import { requireAuth } from "@/lib/auth-requerido";
import { dadosServidor } from "@/lib/dados.server";

/**
 * Envia um aviso importante para os e-mails cadastrados em Parâmetros.
 * Enquanto não houver um domínio de e-mail configurado para o projeto,
 * o aviso é apenas registrado no servidor (sem quebrar o fluxo do usuário).
 */
export const enviarAvisoImportante = createServerFn({ method: "POST" })
  .middleware([requireAuth])
  .validator((input: { acao: string; detalhe: string; autor: string; forcar?: boolean }) => input)
  .handler(async ({ data, context }) => {
    const { data: params } = await (
      await dadosServidor(context.cliente)
    )
      .from("app_params")
      .select("emails_notificacao, ntfy_topico, ntfy_ativo, nome_app")
      .maybeSingle();

    const destinatarios = String(params?.emails_notificacao ?? "")
      .split(/[\n,;]/)
      .map((e) => e.trim())
      .filter((e) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e));

    // Notificação push via ntfy (https://ntfy.sh)
    const topico = String((params as { ntfy_topico?: string } | null)?.ntfy_topico ?? "").trim();
    const ativo = (params as { ntfy_ativo?: boolean } | null)?.ntfy_ativo ?? true;
    let push = false;
    if (topico && (ativo || data.forcar === true)) {
      const { registrarLog } = await import("@/lib/log-servidor.server");
      registrarLog(
        "ntfy",
        `Requisição externa: enviando notificação push para ntfy.sh (tópico "${topico}").`,
      );
      try {
        const resp = await fetch(`https://ntfy.sh/${encodeURIComponent(topico)}`, {
          method: "POST",
          headers: {
            Title: String(
              (params as { nome_app?: string } | null)?.nome_app || "Milky Moo Palmares",
            ),
            Tags: "ice_cream",
            Priority: "default",
          },
          body: `${data.acao}\n${data.detalhe}\nPor: ${data.autor}`,
        });
        push = resp.ok;
        if (!resp.ok) {
          const texto = await resp.text();
          console.error("[ntfy] falha", resp.status, texto);
          registrarLog("ntfy", `Falha ao enviar notificação push [${resp.status}].`, {
            nivel: "erro",
            detalhes: texto,
          });
        } else {
          registrarLog("ntfy", "Notificação push enviada com sucesso para o ntfy.", {
            nivel: "sucesso",
          });
        }
      } catch (e) {
        console.error("[ntfy] erro", e);
        registrarLog("ntfy", `Falha de rede ao enviar notificação push: ${(e as Error).message}`, {
          nivel: "erro",
        });
      }
    }

    if (destinatarios.length > 0) {
      console.info("[aviso importante]", {
        destinatarios,
        acao: data.acao,
        detalhe: data.detalhe,
        autor: data.autor,
      });
    }

    return { enviados: destinatarios.length, push };
  });
